module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('gmap-map', {
    ref: "mapRef",
    style: (_vm.sidebarRight),
    attrs: {
      "center": _vm.center,
      "zoom": _vm.zoom,
      "map-type-id": "terrain",
      "id": "admin-map"
    }
  }, [_vm._l((_vm.filteredDrivers), function(driver, index) {
    return (driver.location.latitude && driver.location.longitude) ? _c('gmap-marker', {
      key: index,
      attrs: {
        "position": {
          lat: parseFloat(driver.location.latitude),
          lng: parseFloat(driver.location.longitude)
        },
        "clickable": true,
        "draggable": false,
        "icon": {
          url: _vm.iconUrl(driver, 'driver'),
          scaledSize: _vm.iconScale('driver')
        }
      },
      on: {
        "click": function($event) {
          _vm.handleDriverClick(driver, 'driver')
        }
      }
    }, [(driver.owner && !_vm.isClient) ? _c('gmap-info-window', {
      attrs: {
        "opened": _vm.currentInfo.type === 'driver' && _vm.currentInfo.id === driver.id
      },
      on: {
        "closeclick": function($event) {
          _vm.closeInfoWindow()
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(driver.name))]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((driver.trucks), function(truck) {
      return [_c('strong', [_vm._v("Truck: ")]), _vm._v(_vm._s(truck.registration) + " - " + _vm._s(truck.company)), _c('br')]
    }), _vm._v(" "), (driver.load && driver.load.status === 'in_progress') ? [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Job:")]), _vm._v("\n          " + _vm._s(driver.load.job) + " - " + _vm._s(driver.load.from) + " to " + _vm._s(driver.load.to) + "\n          "), _c('br')] : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Last Location: ")]), _vm._v(_vm._s(driver.location.age)), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Available Since: ")]), _vm._v(_vm._s(driver.age) + "\n        "), _c('br')], 2) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.filteredJobs), function(job, index) {
    return _c('gmap-marker', {
      key: index,
      attrs: {
        "position": {
          lat: parseFloat(job.location_from.latitude),
          lng: parseFloat(job.location_from.longitude)
        },
        "clickable": true,
        "draggable": false,
        "icon": {
          url: _vm.iconUrl(job, 'job'),
          scaledSize: _vm.iconScale('job')
        }
      },
      on: {
        "click": function($event) {
          _vm.handleJobClick(job)
        }
      }
    })
  }), _vm._v(" "), (_vm.selectedJob) ? _c('gmap-marker', {
    attrs: {
      "position": {
        lat: parseFloat(_vm.selectedJob.location_to.latitude),
        lng: parseFloat(_vm.selectedJob.location_to.longitude)
      },
      "clickable": false,
      "draggable": false,
      "icon": {
        url: _vm.iconUrl(_vm.selectedJob, 'job-to'),
        scaledSize: _vm.iconScale('job')
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedJob) ? _c('gmap-polyline', {
    attrs: {
      "draggable": false,
      "editable": false,
      "path": _vm.polylinePath,
      "options": {
        strokeWeight: 2,
        strokeOpacity: 0.5,
        deepWatch: true
      }
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('filters', {
    style: (_vm.sidebarWidth),
    attrs: {
      "drivers": _vm.drivers,
      "jobs": _vm.jobs
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  }), _vm._v(" "), _c('job-details', {
    model: {
      value: (_vm.selectedJob),
      callback: function($$v) {
        _vm.selectedJob = $$v
      },
      expression: "selectedJob"
    }
  }), _vm._v(" "), _c('truck-details', {
    model: {
      value: (_vm.selectedDriver),
      callback: function($$v) {
        _vm.selectedDriver = $$v
      },
      expression: "selectedDriver"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn-map-filters active",
    style: (_vm.filterPosition),
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleToggleSidebar
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "height": "24",
      "viewBox": "0 0 24 24",
      "width": "24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }
  }), _c('path', {
    attrs: {
      "d": "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
    }
  })])]), _vm._v(" "), _c('legend-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn-map-legend",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": ".modal-map-legend"
    }
  }, [_c('i', {
    staticClass: "far fa-map-signs"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-77aabd52"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/Map.vue
// module id = 1044
// module chunks = 0